import React, { useState } from "react";
import Staffs from "./Staffs";
import AddStaff from "./AddStaff";
import StaffContext from "../../context/StaffManagementContext";
import { Box, Tab, Tabs } from "@mui/material";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import { useContext, useEffect } from "react";
import OfficeContext from "../../context/OfficeContext";
import CustomizedSnackbars from "../300/curriculum/CustomizedSnackbars";
import { useLocation } from "react-router-dom";
import AddButton from "../../components/300/AddButton";
import useAuth from "../../hooks/useAuth";
import StaffRequest from "./StaffRequest";
function StaffManagement() {
  const api = useAxiosPrivate();
  let location = useLocation();
  const { user } = useAuth();

  const [value, setValue] = useState("course");

  //for Snackbar
  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [message, setMessage] = useState({
    message: "",
    type: "",
  });

  const staffContext = useContext(StaffContext);
  const officeContext = useContext(OfficeContext);
  useEffect(() => {
    api.get("staff/staffs").then((res) => {
      staffContext.dispatch({
        type: "loadStaff",
        staffs: res.data.staffs,
      });
    });
    api.get("office/offices").then((res) => {
      officeContext.officeDispatch({
        type: "loadOffice",
        offices: res.data.offices,
      });
    });
    api
      .get("rank/ranks")
      .then((res) => {
        console.log("From the database", res);
        staffContext.rankDispatch({
          type: "loadRank",
          ranks: res.data.ranks,
        });
      })
      .catch((err) => console.log(err));
    api.get("status/statuses").then((res) => {
      console.log("From the database", res);
      staffContext.statusDispatch({
        type: "loadStatus",
        statuses: res.data.statuses,
      });
    });
  }, []);
  useEffect(() => {
    if (location.state?.message) {
      setSnackBarOpen(location.state.open);
      setMessage(location.state.message);
    }
    window.history.replaceState({}, document.title);
  }, []);

  return (
    <>
      <Tabs
        value={staffContext.tabState}
        onChange={(event, newValue) => {
          staffContext.setTabState(newValue);
        }}
      >
        {user.roles.includes(351) && (
          <Tab label="Staff List" value={"staffList"} />
        )}
        {user.roles.includes(301) && (
          <Tab label="Staff Requests" value={"requestList"} />
        )}
      </Tabs>
      <Box>
        {staffContext.tabState === "staffList" && (
          <AddButton
            link={{
              label: "Add Staff",
              href: "/staff_management/addStaff",
            }}
          />
        )}
        {staffContext.tabState === "staffList" ? <Staffs /> : <StaffRequest />}

        {snackBarOpen && (
          <CustomizedSnackbars
            {...{ setSnackBarOpen, snackBarOpen, message, overlay: true }}
          />
        )}
      </Box>
    </>
  );
}

export default StaffManagement;
